import { RootState } from "../../../store/indexReducers";

// NAVIGATION
export const activeRoute = (state: RootState) =>
  state.navigationReducer.activeRoute;
export const showSettings = (state: RootState) =>
  state.navigationReducer.isSettingsPanel;
